import { StoreProductEnum, SubscriptionType, UpgradeEvent } from "@knowt/syncing/graphql/schema";

export enum StripeStatus {
    INCOMPLETE = "incomplete",
    ACTIVE = "active",
    PAUSED = "paused",
    PAST_DUE = "past_due",
    CANCELLED = "canceled",
    TRIALING = "trialing",
    UNPAID = "unpaid",
}

export const SUBSCRIPTION_PRODUCT_IDS: Record<string, SubscriptionType> = {
    prod_NIqN82fvRxPrvK: SubscriptionType.SUPPORTER,
    prod_NRpokN28CVHxDg: SubscriptionType.PRO,
    prod_NRpoA3PM9lSMLA: SubscriptionType.LIMITLESS,
    prod_Py0pJmUllHayOw: SubscriptionType.TEACHER_PRO,
    prod_Py0qL9Cot0cJwH: SubscriptionType.TEACHER_LIMITLESS,
};

export const FEATURES_BY_SUBSCRIPTION_TYPE = {
    [SubscriptionType.BASIC]: [],
    [SubscriptionType.SUPPORTER]: [
        UpgradeEvent.FOLDER_COLOR,
        UpgradeEvent.FOLDER_EMOJI,
        UpgradeEvent.PASSWORD_PROTECT,
        UpgradeEvent.PERSONALIZE_PROFILE,
        UpgradeEvent.USERNAME_CHANGE,
        UpgradeEvent.REMOVE_ADS,
    ],
    [SubscriptionType.LIMITLESS]: [
        UpgradeEvent.FOLDER_COLOR,
        UpgradeEvent.FOLDER_EMOJI,
        UpgradeEvent.PASSWORD_PROTECT,
        UpgradeEvent.PERSONALIZE_PROFILE,
        UpgradeEvent.USERNAME_CHANGE,
        UpgradeEvent.REMOVE_ADS,
        UpgradeEvent.MAX_VIDEO_AI,
        UpgradeEvent.MAX_PDF_AI,
        UpgradeEvent.MAX_NOTE_FLASHCARDS,
        UpgradeEvent.MAX_NOTE_TESTS,
        UpgradeEvent.MAX_PROMPT,
        UpgradeEvent.MAX_EXPLAIN,
        UpgradeEvent.MAX_FRQ,
    ],
    [SubscriptionType.TEACHER_PRO]: [
        UpgradeEvent.FOLDER_COLOR,
        UpgradeEvent.FOLDER_EMOJI,
        UpgradeEvent.PASSWORD_PROTECT,
        UpgradeEvent.PERSONALIZE_PROFILE,
        UpgradeEvent.USERNAME_CHANGE,
        UpgradeEvent.REMOVE_ADS,
        UpgradeEvent.STUDENT_PROGRESS,
        UpgradeEvent.STUDY_RESTRICTIONS,
    ],
    [SubscriptionType.TEACHER_LIMITLESS]: [
        UpgradeEvent.FOLDER_COLOR,
        UpgradeEvent.FOLDER_EMOJI,
        UpgradeEvent.PASSWORD_PROTECT,
        UpgradeEvent.PERSONALIZE_PROFILE,
        UpgradeEvent.USERNAME_CHANGE,
        UpgradeEvent.REMOVE_ADS,
        UpgradeEvent.STUDENT_PROGRESS,
        UpgradeEvent.STUDY_RESTRICTIONS,
        UpgradeEvent.MAX_VIDEO_AI,
        UpgradeEvent.MAX_PDF_AI,
        UpgradeEvent.MAX_NOTE_FLASHCARDS,
        UpgradeEvent.MAX_NOTE_TESTS,
        UpgradeEvent.MAX_PROMPT,
        UpgradeEvent.MAX_EXPLAIN,
        UpgradeEvent.MAX_FRQ,
    ],
};

export const featureTypeToStoreProductEnum = (event: UpgradeEvent): StoreProductEnum => {
    switch (event) {
        case UpgradeEvent.FOLDER_COLOR:
        case UpgradeEvent.FOLDER_EMOJI:
            return StoreProductEnum.FOLDER_COLORS;

        case UpgradeEvent.PERSONALIZE_PROFILE:
            return StoreProductEnum.PROFILE_COLOR;

        default:
            return null;
    }
};

export enum STUDENT_PRICE_ID {
    SUPPORTER_MONTHLY_6 = "price_1PTpquKXJM8qxW7RoAbh1IR6",
    SUPPORTER_MONTHLY_8 = "price_1QN4n3KXJM8qxW7RZIkPQzBj",
    SUPPORTER_YEARLY_24 = "price_1Pdaz2KXJM8qxW7RqZl7U8D7",

    PRO_MONTHLY_5 = "price_1NkQSvKXJM8qxW7RF9yW421Y",
    PRO_YEARLY_36 = "price_1NkQS1KXJM8qxW7RVOsBZ30G",

    LIMITLESS_MONTHLY_13 = "price_1O9qZoKXJM8qxW7RGJuSkxJE",
    LIMITLESS_MONTHLY_15 = "price_1QN4p3KXJM8qxW7RRPRI9VUU",
    LIMITLESS_YEARLY_96 = "price_1PdazxKXJM8qxW7RbKPH7v36",
    LIMITLESS_YEARLY_60 = "price_1QkUA6KXJM8qxW7R7mXyGhXo",

    // @deprecated SUPPORTER_MONTHLY_2 = "price_1MYEghKXJM8qxW7RXFMYKJrN",
    // @deprecated SUPPORTER_YEARLY_12 = "price_1NlXXgKXJM8qxW7RTQdhKQeN",
    // @deprecated SUPPORTER_YEARLY_10 = "price_1MYEghKXJM8qxW7RjOf8sVWh",
    // @deprecated PRO_MONTHLY_3 = "price_1MpAckKXJM8qxW7R4mDjj3AY",
    // @deprecated PRO_YEARLY_26 = "price_1MpAepKXJM8qxW7RNih8tRlD",
    // @deprecated LIMITLESS_MONTHLY_8 = "price_1MpAfPKXJM8qxW7R5CYpcqkh",
    // @deprecated LIMITLESS_MONTHLY_10 = "price_1NkQTWKXJM8qxW7Rr1nSmbOh",
    // @deprecated LIMITLESS_YEARLY_120 = "price_1O9qZAKXJM8qxW7R2mKRUJeP",
    // @deprecated LIMITLESS_YEARLY_48 = "price_1Q7EwTKXJM8qxW7Rwcpmjtrx",
}

export enum PAYPAL_STUDENT_PRICE_IDS {
    // SUPPORTER
    price_1PTpquKXJM8qxW7RoAbh1IR6 = "P-4EF79829D8113910WM42QQBY",
    price_1Pdaz2KXJM8qxW7RqZl7U8D7 = "P-53376773S6296421GM42Q4DA",

    // LIMITLESS
    price_1O9qZoKXJM8qxW7RGJuSkxJE = "P-6CY900401D9965811M42Q4NI",
    price_1Q7EwTKXJM8qxW7Rwcpmjtrx = "P-9CM52391SV791783TM42Q4UA",
    price_1QkUA6KXJM8qxW7R7mXyGhXo = "P-1DY57906024004642M6KUGCA",
}

export enum TEACHER_PRICE_ID {
    PRO_MONTHLY_8 = "price_1PVxsGKXJM8qxW7RvhLCEjNk",
    PRO_YEARLY_36 = "price_1Pdb0YKXJM8qxW7RMmVEMDW9",

    LIMITLESS_MONTHLY_13 = "price_1PVxlQKXJM8qxW7RU5DR86XV",
    LIMITLESS_MONTHLY_15 = "price_1QN4szKXJM8qxW7Rv4ap0ZZL",
    LIMITLESS_YEARLY_96 = "price_1Pdb17KXJM8qxW7RcHRasniV",
    LIMITLESS_YEARLY_60 = "price_1QkUAmKXJM8qxW7RkyY7W44n",

    // @deprecated PRO_MONTHLY_5 = "price_1P84ndKXJM8qxW7RwWN8Meor",
    // @deprecated LIMITLESS_MONTHLY_10 = "price_1P84p3KXJM8qxW7RxDQWRz5A",
    // @deprecated LIMITLESS_YEARLY_48 = "price_1QIY5PKXJM8qxW7RtuBtQkVu",
}

export enum PAYPAL_TEACHER_PRICE_IDS {
    // TEACHER_PRO
    price_1PVxsGKXJM8qxW7RvhLCEjNk = "P-0FG55395WR3859258M42Q43Y",
    price_1Pdb0YKXJM8qxW7RMmVEMDW9 = "P-7XY64640VG287904VM42Q5DQ",

    // TEACHER_LIMITLESS
    price_1PVxlQKXJM8qxW7RU5DR86XV = "P-8CP34293SN024591RM42Q5LI",
    price_1Pdb17KXJM8qxW7RcHRasniV = "P-32R14579DY9806505M42Q5RI",
    price_1QkUAmKXJM8qxW7RkyY7W44n = "P-6ES987195H5182610M6KUF4A",
}

export type PaymentFrequency = "Month" | "Year";

export type PricingOption = {
    type:
        | "Enterprise"
        | "Teacher Basic"
        | "Teacher Plus"
        | "Teacher Ultra"
        | "Student Basic"
        | "Student Plus"
        | "Student Ultra";
    subscriptionType: SubscriptionType;
    interval: PaymentFrequency;
    price: string;
    priceId?: STUDENT_PRICE_ID | TEACHER_PRICE_ID;
    oldPrice?: string;
    pricePerMonth?: string;
    isPicker?: boolean;
    needContactUs?: boolean;
    androidPriceId?: string;
};

type STUDENTS_OPTION =
    | "MONTHLY_BASIC"
    | "MONTHLY_SUPPORTER"
    | "ANNUALLY_SUPPORTER"
    | "MONTHLY_LIMITLESS"
    | "ANNUALLY_LIMITLESS"
    | "ANNUALLY_LIMITLESS_HIGHER";

type TEACHERS_OPTION =
    | "MONTHLY_BASIC"
    | "MONTHLY_PRO"
    | "ANNUALLY_PRO"
    | "MONTHLY_LIMITLESS"
    | "ANNUALLY_LIMITLESS"
    | "ANNUALLY_LIMITLESS_HIGHER";

export const STUDENTS_PRICING_OPTIONS: Record<STUDENTS_OPTION, PricingOption> = {
    MONTHLY_BASIC: {
        type: "Student Basic",
        subscriptionType: SubscriptionType.BASIC,
        interval: "Month",
        price: "$0",
        pricePerMonth: "$0",
    },
    MONTHLY_SUPPORTER: {
        type: "Student Plus",
        subscriptionType: SubscriptionType.SUPPORTER,
        interval: "Month",
        price: "$7.99",
        pricePerMonth: "$7.99",
        priceId: STUDENT_PRICE_ID.SUPPORTER_MONTHLY_8,
    },
    ANNUALLY_SUPPORTER: {
        type: "Student Plus",
        subscriptionType: SubscriptionType.SUPPORTER,
        interval: "Year",
        price: "$23.99",
        pricePerMonth: "$1.99",
        oldPrice: "$7.99",
        priceId: STUDENT_PRICE_ID.SUPPORTER_YEARLY_24,
    },
    MONTHLY_LIMITLESS: {
        type: "Student Ultra",
        subscriptionType: SubscriptionType.LIMITLESS,
        interval: "Month",
        price: "$14.99",
        pricePerMonth: "$14.99",
        priceId: STUDENT_PRICE_ID.LIMITLESS_MONTHLY_15,
    },
    ANNUALLY_LIMITLESS: {
        type: "Student Ultra",
        subscriptionType: SubscriptionType.LIMITLESS,
        interval: "Year",
        price: "$59.99",
        pricePerMonth: "$4.99",
        oldPrice: "$14.99",
        priceId: STUDENT_PRICE_ID.LIMITLESS_YEARLY_60,
        androidPriceId: `limitless:${STUDENT_PRICE_ID.LIMITLESS_YEARLY_60?.toLowerCase().replace("_", "-")}`,
    },
    ANNUALLY_LIMITLESS_HIGHER: {
        type: "Student Ultra",
        subscriptionType: SubscriptionType.LIMITLESS,
        interval: "Year",
        price: "$95.99",
        pricePerMonth: "$7.99",
        oldPrice: "$14.99",
        priceId: STUDENT_PRICE_ID.LIMITLESS_YEARLY_96,
    },
};

export const TEACHERS_PRICING_OPTIONS: Record<TEACHERS_OPTION, PricingOption> = {
    MONTHLY_BASIC: {
        type: "Teacher Basic",
        subscriptionType: SubscriptionType.BASIC,
        interval: "Month",
        price: "$0",
    },
    MONTHLY_PRO: {
        type: "Teacher Plus",
        subscriptionType: SubscriptionType.TEACHER_PRO,
        interval: "Month",
        price: "$7.99",
        priceId: TEACHER_PRICE_ID.PRO_MONTHLY_8,
    },
    ANNUALLY_PRO: {
        type: "Teacher Plus",
        subscriptionType: SubscriptionType.TEACHER_PRO,
        interval: "Year",
        price: "$35.99",
        pricePerMonth: "$2.99",
        oldPrice: "$7.99",
        priceId: TEACHER_PRICE_ID.PRO_YEARLY_36,
    },
    MONTHLY_LIMITLESS: {
        type: "Teacher Ultra",
        subscriptionType: SubscriptionType.TEACHER_LIMITLESS,
        interval: "Month",
        price: "$14.99",
        priceId: TEACHER_PRICE_ID.LIMITLESS_MONTHLY_13,
    },
    ANNUALLY_LIMITLESS: {
        type: "Teacher Ultra",
        subscriptionType: SubscriptionType.TEACHER_LIMITLESS,
        interval: "Year",
        price: "$59.99",
        pricePerMonth: "$4.99",
        oldPrice: "$14.99",
        priceId: TEACHER_PRICE_ID.LIMITLESS_YEARLY_60,
    },
    ANNUALLY_LIMITLESS_HIGHER: {
        type: "Teacher Ultra",
        subscriptionType: SubscriptionType.TEACHER_LIMITLESS,
        interval: "Year",
        price: "$95.99",
        pricePerMonth: "$7.99",
        oldPrice: "$14.99",
        priceId: STUDENT_PRICE_ID.LIMITLESS_YEARLY_96,
    },
};

export const getPlanDetailsFromPriceId = (priceId: string) => {
    return (
        Object.values(STUDENTS_PRICING_OPTIONS).find(option => option.priceId === priceId) ??
        Object.values(TEACHERS_PRICING_OPTIONS).find(option => option.priceId === priceId)
    );
};

export const getPlanAnnualPrice = (subscriptionType: SubscriptionType) => {
    switch (subscriptionType) {
        case SubscriptionType.SUPPORTER:
            return 6.0;
        case SubscriptionType.LIMITLESS:
            return 95.99;
        case SubscriptionType.TEACHER_PRO:
            return 35.99;
        case SubscriptionType.TEACHER_LIMITLESS:
            return 95.99;
        default:
            return 0;
    }
};

export const getPlanName = (subscriptionType: SubscriptionType | null | undefined, isTrialing?: boolean) => {
    switch (subscriptionType) {
        case SubscriptionType.BASIC:
            return "Basic";
        case SubscriptionType.SUPPORTER:
            return "Student Plus";
        case SubscriptionType.PRO:
            return "Student Pro";
        case SubscriptionType.LIMITLESS:
            return "Student Ultra";
        case SubscriptionType.TEACHER_PRO:
            if (isTrialing) {
                return "Plus Free Trial";
            }
            return "Teacher Plus";
        case SubscriptionType.TEACHER_LIMITLESS:
            if (isTrialing) {
                return "Ultra Free Trial";
            }
            return "Teacher Ultra";
        default:
            return "Basic";
    }
};
